import { createFeatureSelector, createSelector } from '@ngrx/store';
import { JUNIOR_PILOT_STORE_NAME, JuniorPilotState } from './junior-pilot.state';

/** Select JuniorPilot State */
export const selectJuniorPilotState = createFeatureSelector<JuniorPilotState>(JUNIOR_PILOT_STORE_NAME);

/** Select JuniorPilot isPending status */
export const selectJuniorPilotIsPendingStatus = createSelector(selectJuniorPilotState, (state) => !!state.isPending);

/** Select JuniorPilot isFailure status */
export const selectJuniorPilotIsFailureStatus = createSelector(selectJuniorPilotState, (state) => !!state.isFailure);
